import { legacyRouteQuery } from '../models/legacyQuerySelection';
import { legacyCollectionStatus } from '../models/legacyCollectionStatus';
import { invalidateLegacyFinder, prefetchLegacyFinder } from '../api/legacyFinderRepository';

// A saved finder is already persisted by change-finder. Load it on its actual
// root collection route, rather than reloading the previous Platinum/favorites URL.
export async function activateSavedQuery(vm, { preloadFilters = false } = {}) {
  invalidateLegacyFinder();
  if (preloadFilters) prefetchLegacyFinder((vm._g_User || {}).uid || (vm.$store && vm.$store.state.user_id) || '').catch(() => {});
  try {
    window.sessionStorage.removeItem('ticker_search_by_user');
    if (vm.$route.params.param1) await vm.$router.push('/app/graficador-dinamico');
    if (vm._isDestroyed) return false;
    const query = vm.legacyQuery, token = query && query.capture();
    await (query ? query.reload() : vm.getStocks());
    if (vm._isDestroyed || legacyCollectionStatus.error || (query && !query.isCurrent(token))) return false;
    if (query) query.select('saved-search');
    return true;
  } catch (_) { return false; }
}

// Restore the routed query even when a description result replaced its list
// without changing the URL. Re-selecting the actual active query is a no-op.
export async function navigateLegacyQuery(vm, path) {
  window.sessionStorage.removeItem('ticker_search_by_user');
  if (vm.$route.path === path) {
    if (vm.legacyQuery) {
      if (vm.legacyQuery.current().source !== legacyRouteQuery(vm.$route).source) {
        vm.legacyQuery.reset();
        await vm.legacyQuery.reload();
      }
    }
    return;
  }
  await vm.$router.push(path);
}
